// Utility to send frontend logs to backend server
import { apiFetch } from '../lib/apiClient'

type LogLevel = 'debug' | 'info' | 'warn' | 'error'

export function serverLog(level: LogLevel, message: string, data?: unknown) {
  // Check if user is authenticated before sending logs to backend
  // This prevents CORS errors and log spam for unauthenticated users
  const userStr = localStorage.getItem('user');
  const isAuthenticated = userStr && userStr !== 'null' && userStr !== 'undefined';
  
  if (!isAuthenticated) {
    // User not logged in, just console log (dev only)
    if (import.meta.env.DEV) {
      console.log(`[${level.toUpperCase()}] ${message}`, data || '');
    }
    return;
  }
  
  // Only send important logs to backend (not debug) to avoid rate limiting
  if (level !== 'debug') {
    apiFetch('/api/logs', {
      method: 'POST',
      body: JSON.stringify({
        level,
        message,
        data,
        timestamp: new Date().toISOString(),
        source: 'frontend'
      })
    }).catch(() => {
      // If backend is down, fall back to console (dev only)
      if (import.meta.env.DEV) {
        console.log(`[${level.toUpperCase()}] ${message}`, data || '')
      }
    })
  } else {
    // Debug logs only go to console in dev to prevent rate limiting and production log spam
    if (import.meta.env.DEV) {
      console.log(`[DEBUG] ${message}`, data || '')
    }
  }
}

// Convenience methods
export const logger = {
  debug: (message: string, data?: unknown) => serverLog('debug', message, data),
  info: (message: string, data?: unknown) => serverLog('info', message, data),
  warn: (message: string, data?: unknown) => serverLog('warn', message, data),
  error: (message: string, data?: unknown) => serverLog('error', message, data),
}